/** Dados realizados para os KPI's de produtividade */
export class Realizado {
    quantidadeItens: number;
    percParticipacaoItens: number;
    percParticipacaoCrescimentoItens: number;

    constructor(props: Partial<Realizado>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Realizado {
        return new Realizado(JSON.parse(json));
    }
}
